import Styled, { css } from 'styled-components';

import { media } from '../../lib/StyledComponents';
import { ListNumber } from '../List/ListNumber';

// ver-sidebar-steps does stuff to this..
export const VerSidebarHeadline = Styled.h4`
  font-size: 1.7rem;
  line-height: 1.4;
  font-weight: 700;
  margin-bottom: 0.75em;
`;

VerSidebarHeadline.displayName = 'VerSidebarHeadline';

export const VerSidebarGroup = Styled.div`
  &:not(:last-child) {
    margin-bottom: 2em;
  }
`;

VerSidebarGroup.displayName = 'VerSidebarGroup';

const VerSidebar = Styled.div<{ showBorder?: boolean }>`
  ${({ showBorder = true }) =>
    (css`
      *:last-child {
        margin-bottom: 0;
      }

      strong {
        font-weight: 700;
      }

      ${props => showBorder && css`
        ${media.large`
          padding: 1.75em 1.5em;
          border: 1px solid ${props.theme.colorSlate5};
          box-shadow: 0 0 2px ${props.theme.colorSlate5};
        `}
      `}

      ${VerSidebarHeadline} {
        margin-bottom: 1em;
      }

      ${ListNumber} {
        margin-top: 0;
        color: ${({ theme: { brand } }) => brand.colorSecondary};
        font-weight: 700;

        li {
          color: ${({ theme: { text } }) => text.colorText};
          font-weight: initial;
        }
      }
    `)
  }
`;

VerSidebar.displayName = 'VerSidebar';

export default VerSidebar;
